module.exports = __webpack_public_path__ + "static/media/vote-no.cf5178d1.svg";